import { Component, OnInit } from '@angular/core';
import { classificationInterface } from 'src/app/util/interfaces/classification';
import { ClassificationService } from '../service/classification.service';
import { serviceTypeInterface } from 'src/app/util/interfaces/requestClassification';

@Component({
	selector: 'register-form-classification',
	templateUrl: './classification.component.html',
	styleUrls: ['./classification.component.scss'],
})
export class ClassificationComponent implements OnInit {
	constructor(private ClassificationService: ClassificationService) {}

	ngOnInit(): void {
		this.ClassificationService.getClassificationServiceType().subscribe(
			(availableServiceTypes) => (this.availableServiceTypes = availableServiceTypes)
		);
	}

	availableServiceTypes: string[] | serviceTypeInterface[] = [''];
	selectedServiceType = '';
	availableClassificationList: classificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
	};
	selectedClassification: classificationInterface = {
		serviceType: [],
		scope: [],
		category: [],
		topic: [],
		solutionArea: [],
	};
}
